<template>
  <div>
		<div v-if="errorUserPending" class="alert alert-error">
      Sorry but this user has a pending gift subscription.
      If you would like to activate this user sooner, please contact us.
		</div>

		<div v-if="errorResettingPassword" class="alert alert-error">
      Sorry, there was a problem resetting your password.
      Please try again or contact technical support.
		</div>

    <!-- Form -->
    <form
      ref="resetForm"
      class="el-form el-form--label-top"
      role="form"
      method="POST"
      v-on:submit="resetPassword"
      v-bind:action="postUrl">
      <input type="hidden" name="_token" v-model="csrfToken">

      <!-- E-Mail Address -->
      <div class="el-form-item" v-bind:class="{ 'is-error': error }">
        <label class="el-form-item__label">Email</label>

        <div class="el-form-item__content">
          <input type="email" class="el-form-item__input" name="email" v-model="oldEmail" autofocus>
          <span v-if="error" class="el-form-item__error">{{ error }}</span>
        </div>
      </div>

      <!-- Send Password Reset Link Button -->
      <button type="submit" class="btn btn-default" v-waves.light>
        Send Password Reset Link
      </button>
    </form>
  </div>
</template>

<style>
</style>

<script>
  function checkServerError (response) {
    if (!response.ok) {
      throw new Error(response.statusText)
    }

    return response
  }

  export default {
    mixins: [],
    props: ['csrfToken', 'postUrl', 'error'],
    mounted () {
    },
    computed: {
    },
    data () {
      return {
        oldEmail: '',
        errorUserPending: false,
        errorResettingPassword: false,
      }
    },
    methods: {
      async resetPassword (evt) {
        evt.preventDefault()

        try {
          if (await this.userIsPendingGift()) {
            this.errorUserPending = true
          } else {
            this.$refs.resetForm.submit()
          }
        } catch (err) {
          evt.preventDefault()
          console.error(err)
          this.errorResettingPassword = true
        }
      },

      async serverRequest (url, config = {}) {
        config.method = config.method || 'GET'
        config.headers = {
          'Content-Type': 'application/json',
          'X-CSRF-TOKEN': this.csrfToken
        }

        if (config.body) config.body = JSON.stringify(config.body)

        return fetch(url, config)
          .then(checkServerError)
          .then(x => x.json())
      },

      async userIsPendingGift () {
        return await this.serverRequest(`/is-pending-gift?email=${this.oldEmail}`, { method: 'GET' })
          .then(x => x.is_pending)
      }
    }
  }
</script>

